import React from "react";
import Modal from "react-bootstrap/Modal";
import ReactDropdown from "react-dropdown";
import TextInputOnRow from "components/GenericComponent/TextInputOnRow";
import TextInputTwoRow from "components/GenericComponent/TextInputTwoRow";
import TextInputTwoRowReverse from "components/GenericComponent/TextInputTwoRowReverse";
import { PopoversBootrap } from "components/GenericComponent/PopoversBootrap";
import DateTimePicker from "components/GenericComponent/DateTimePicker";
import { currentDate } from "utils/formatDate";
import { formatDayMonth } from "utils/formatDate";
import themMoiKhachHangApi from "../../../service/themMoiKhachHangApi";
import { pushNotification } from "../../../utils/notifications";
import userApi from "../../../service/userApi";
import configsRole from "utils/configsRole";
import { kiemTraQuyen, quyenBanDau } from "utils/quyenNguoiDung";
class ThemMoiKhachHang extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      objKhachHang: {
        CustomerId: 0,
        Code: "",
        FirstName: "",
        LastName: "",
        Alias: "",
        YearBirth: "",
        HKTT: "",
        HKTTLocation: "",
        Address: "",
        LocationID: "",
        CMT: "",
        DateCMT: "",
        AddressCMT: "",
        Profession: "",
        WorkAddress: "",
        Income: 0,
        //   Phone { get; set; }
        PersonContact: "",
        PhoneContact: "",
        //  Img { get; set; }
        //   NameWife { get; set; }
        //    PhoneWife { get; set; }
        //    ProfessionWife { get; set; }
        //  NameFather { get; set; }
        //    PhoneFather { get; set; }
        //    NameMother { get; set; }
        //   PhoneMother { get; set; }
        //   ProfessionMother { get; set; }
        //    MaxDebt { get; set; }
        //   Status { get; set; }
        //    OrientNote { get; set; }
        Note: "",
        UserName: this.props.user.currentUser.UserName ?? "",
        //   NoteFamily { get; set; }
        //    DinhDanh { get; set; }
        //    Email { get; set; }
        //    Birthday { get; set; }
        DebtLevel: 0,
        //    CustomerName { get; set; }
        NguonKhId: 0,
        //    TenNguonKh { get; set; }
        //   TinhTrang { get; set; }
        //   NguoiTheoDoi { get; set; }
        LoaiDoiTac: 1,
        //    IsEditCustomer { get; set; }
        //    ImgObj { get; set; }
      },
      errors: {
        CustomerName: null,
        Email: null,
      },
      nhanVienOption: [],
      quyenThongTinKhac: quyenBanDau(configsRole.sRole.thongtinkhachvay_thongtinkhac),
      quyenThanhPhanGiaDinh: quyenBanDau(configsRole.sRole.thongtinkhachvay_thanhphangiadinh),
      quyenThongTinChoVay: quyenBanDau(configsRole.sRole.thongtinkhachvay_thongtinchovay),
      quyenGhiChu: quyenBanDau(configsRole.sRole.thongtinkhachvay_thongtinkhac_ghichu),
      quyenThongTinKhacGiaDinh: quyenBanDau(configsRole.sRole.thongtinkhachvay_thanhphangiadinh_thongtinkhac),
    };
    this.CustomerName = React.createRef();
    this.Email = React.createRef();
    userApi.combo().then((response) => {
      let { nhanVienOption } = this.state;
      nhanVienOption = response.data;
      this.setState({ nhanVienOption });
      // const dataComboUser = response.data.map((item) => ({
      //   value: item.value,
      //   label: item.label,
      // }));
      // setListUser(dataComboUser);
    });
  }

  componentDidMount() {
    //Các quyền tab con của nhóm "Thông tin khách vay"
    //Quyền cấp 3: tắt thì chỉ ẩn đúng ô "Ghi chú" / "Thông tin khác"
    Promise.all([
      kiemTraQuyen(configsRole.sRole.thongtinkhachvay_thongtinkhac),
      kiemTraQuyen(configsRole.sRole.thongtinkhachvay_thanhphangiadinh),
      kiemTraQuyen(configsRole.sRole.thongtinkhachvay_thongtinchovay),
      kiemTraQuyen(configsRole.sRole.thongtinkhachvay_thongtinkhac_ghichu),
      kiemTraQuyen(configsRole.sRole.thongtinkhachvay_thanhphangiadinh_thongtinkhac),
    ]).then(
      ([
        quyenThongTinKhac,
        quyenThanhPhanGiaDinh,
        quyenThongTinChoVay,
        quyenGhiChu,
        quyenThongTinKhacGiaDinh,
      ]) =>
        this.setState({
          quyenThongTinKhac,
          quyenThanhPhanGiaDinh,
          quyenThongTinChoVay,
          quyenGhiChu,
          quyenThongTinKhacGiaDinh,
        })
    );
  }

  onChangeData = (field) => (event) => {
    let { objKhachHang } = this.state;
    objKhachHang[field] = event.target.value;
    this.setState({ objKhachHang });
  };

  onChangThuNhap = (field) => (event) => {
    const re = /^[0-9\b]+$/; //rules
    if (event.target.value === "" || re.test(event.target.value)) {
      let { objKhachHang } = this.state;
      objKhachHang.Income = event.target.value;
      this.setState({ objKhachHang });
    }
  };

  onChangeNgaySinh = (evt) => {
    let { objKhachHang } = this.state;
    objKhachHang.Birthday = formatDayMonth(evt);
    this.setState({ objKhachHang });
  };
  onChangeNgayCap = (evt) => {
    let { objKhachHang } = this.state;
    objKhachHang.DateCMT = formatDayMonth(evt);
    this.setState({ objKhachHang });
  };
  _onSelect = (field) => (e) => {
    let { objKhachHang } = this.state;
    if (field === "NguonKhachHang") objKhachHang.NguonKhId = e.target.value;
    else if (field === "DebtLevel") objKhachHang.DebtLevel = e.target.value;
    else if (field === "LoaiDoiTac") objKhachHang.LoaiDoiTac = e.target.value;
    else if (field === "UserName") objKhachHang.UserName = e.target.value;
    this.setState({ objKhachHang });
  };

  onHide = () => {
    let props = this.props;
    props.onHide();
  };
  onSumit = () => {
    let { objKhachHang, errors } = this.state;
    if (
      objKhachHang.CustomerName === "" ||
      objKhachHang.CustomerName == null ||
      objKhachHang.CustomerName == undefined
    ) {
      errors.CustomerName = {
        message: "Nhập tên khách hàng",
      };
      this.CustomerName.current.focus();
      this.setState({ errors });
      return;
    }

    if (
      objKhachHang.Email != undefined &&
      objKhachHang.Email != "" &&
      objKhachHang.Email != null
    ) {
      if (
        !new RegExp(/[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,15}/g).test(
          objKhachHang.Email
        )
      ) {
        errors.Email = {
          message: "Email không đúng định dạng",
        };
        this.Email.current.focus();
        this.setState({ errors });
        return;
      }
    }
    errors.CustomerName = null;
    errors.Email = null;
    this.setState({ errors });

    // else {
    //   errors.CustomerName = null;
    //   this.setState({ errors });
    // }
    //return;
    //objKhachHang.NguonKhId = 19;
    themMoiKhachHangApi.themMoiKhachHang(objKhachHang).then((response) => {
      if (response.data.Error == 0) {
        pushNotification(response.data.Message, "success", "TOP_CENTER", 2000);
        let { onSearch } = this.props;
        onSearch();
      } else
        pushNotification(response.data.Message, "error", "TOP_CENTER", 2000);
    });
    this.onHide();
  };
  render() {
    let props = this.props;
    let {
      objKhachHang,
      errors,
      nhanVienOption,
      quyenThongTinKhac,
      quyenThanhPhanGiaDinh,
      quyenThongTinChoVay,
      quyenGhiChu,
      quyenThongTinKhacGiaDinh,
    } = this.state;
    //Tab đầu tiên còn hiển thị sẽ được gán active
    const tabDauTien = quyenThongTinChoVay
      ? "tab421"
      : quyenThongTinKhac
      ? "tab422"
      : quyenThanhPhanGiaDinh
      ? "tab423"
      : "";
    let { nguonkhachhang } = this.props;
    let {
      CustomerName,
      Birthday,
      Phone,
      CMT,
      DateCMT,
      AddressCMT,
      Email,
      Address,
      HKTT,
      NguonKhId,
      DebtLevel,
      LoaiDoiTac,
      Username,
      Profession,
      WorkAddress,
      Income,
      PersonContact,
      PhoneContact,
      Note,
    } = objKhachHang;
    let { comboNguonKhachHang } = nguonkhachhang;
    return (
      <Modal
        {...props}
        size="modal-xl modal-xl"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="modal-new modal fade text-left popup-detail "
      >
        <Modal.Header>
          <h4 className="modal-title" id="myModalLabel16">
            <span className="btn-icon-right">
              <i className="fas fa-plus"></i>
            </span>
            Thêm mới khách hàng
          </h4>
          <button
            type="button"
            className="close-popup-new"
            data-dismiss="modal"
            aria-label="Close"
            onClick={props.onHide}
          >
            <i className="mdi mdi-close"></i>
          </button>
        </Modal.Header>

        <Modal.Body className="">
          <form className="form tat-toan form-horizontal ">
            <div className="form-body">
              <div className="card collapse-icon accordion-icon-rotate">
                <div
                  id="headingCollapse453"
                  className="card-header border-info"
                  href="#collapse453"
                  aria-expanded="true"
                  aria-controls="collapse453"
                >
                  <a
                    className="card-title lead info collapsed"
                    href={() => false}
                  >
                    <h3>Thông tin cá nhân</h3>
                  </a>
                </div>
                <div
                  id="collapse453"
                  aria-labelledby="headingCollapse453"
                  className="card-collapse collapse show"
                  aria-expanded="true"
                >
                  <div className="card-content mar-15">
                    <div className="card-body">
                      <div className="row">
                        <div className="col-sm-3">
                          <div className="form-group">
                            <label className="label-control"></label>
                            <div className="edit-ava-kh">
                              <label
                                id="projectinput8"
                                className="file center-block ava-kh-add"
                              >
                                <div className="edit-ava-kh">
                                  <img
                                    className="img-responsive"
                                    src="/app-assets/images/no_image.png"
                                    alt=""
                                  />
                                </div>
                                <input type="file" id="file" />
                                <span className="file-custom"></span>
                              </label>
                            </div>
                          </div>
                        </div>

                        <div className="col-sm-9">
                          <div className="row">
                            <div className="col-md-4">
                              <TextInputOnRow
                                labelClass="label-control"
                                inputClass="form-control input-sm"
                                wrapperClass="form-group"
                                labelText="Họ Tên"
                                value={CustomerName}
                                inputProps={{
                                  onChange: this.onChangeData("CustomerName"),
                                  ref: this.CustomerName,
                                }}
                                error={errors.CustomerName}
                              ></TextInputOnRow>
                            </div>
                            <div className="col-md-4">
                              <div className="form-group">
                                <label for="projectinput1">Ngày sinh</label>
                                <DateTimePicker
                                  onChange={this.onChangeNgaySinh}
                                  value={Birthday}
                                  name="Birthday"
                                  placeholder="dd/mm/yyyy"
                                  customInput={
                                    <input
                                      name="Birthday"
                                      placeholder="dd/mm/yyyy"
                                    ></input>
                                  }
                                  error={errors.Birthday}
                                ></DateTimePicker>
                              </div>
                            </div>
                            <div className="col-md-4">
                              <TextInputOnRow
                                labelClass="label-control"
                                inputClass="form-control input-sm"
                                wrapperClass="form-group"
                                labelText="Số điện thoại"
                                value={Phone}
                                inputProps={{
                                  onChange: this.onChangeData("Phone"),
                                }}
                                error={errors.Phone}
                              ></TextInputOnRow>
                            </div>
                            <div className="col-md-4">
                              <TextInputOnRow
                                labelClass="label-control"
                                inputClass="form-control input-sm"
                                wrapperClass="form-group"
                                labelText="Số CCCD"
                                value={CMT}
                                inputProps={{
                                  onChange: this.onChangeData("CMT"),
                                }}
                              ></TextInputOnRow>
                            </div>
                            <div className="col-md-4">
                              <div className="form-group">
                                <label for="projectinput1">Ngày cấp</label>
                                <DateTimePicker
                                  onChange={this.onChangeNgayCap}
                                  value={DateCMT}
                                  name="DateCMT"
                                  placeholder="dd/mm/yyyy"
                                  customInput={
                                    <input
                                      name="DateCMT"
                                      placeholder="dd/mm/yyyy"
                                    ></input>
                                  }
                                ></DateTimePicker>
                              </div>
                            </div>
                            <div className="col-md-4">
                              <TextInputOnRow
                                labelClass="label-control"
                                inputClass="form-control input-sm"
                                wrapperClass="form-group"
                                labelText="Nơi cấp"
                                value={AddressCMT}
                                inputProps={{
                                  onChange: this.onChangeData("AddressCMT"),
                                }}
                              ></TextInputOnRow>
                            </div>

                            <div className="col-md-4">
                              <TextInputOnRow
                                labelClass="label-control"
                                inputClass="form-control input-sm"
                                wrapperClass="form-group"
                                labelText="Email"
                                value={Email}
                                inputProps={{
                                  onChange: this.onChangeData("Email"),
                                  ref: this.Email,
                                }}
                                error={errors.Email}
                              ></TextInputOnRow>
                            </div>

                            <div className="col-md-4">
                              <TextInputOnRow
                                labelClass="label-control"
                                inputClass="form-control input-sm"
                                wrapperClass="form-group"
                                labelText="Địa chỉ"
                                value={Address}
                                inputProps={{
                                  onChange: this.onChangeData("Address"),
                                }}
                              ></TextInputOnRow>
                            </div>

                            <div className="col-md-4">
                              <TextInputOnRow
                                labelClass="label-control"
                                inputClass="form-control input-sm"
                                wrapperClass="form-group"
                                labelText="Hộ khẩu thường trú"
                                value={HKTT}
                                inputProps={{
                                  onChange: this.onChangeData("HKTT"),
                                }}
                              ></TextInputOnRow>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <ul className="nav nav-tabs mt-1 bg-tab">
                  {quyenThongTinChoVay && (
                  <li className="nav-item">
                    <a
                      className={"nav-link" + (tabDauTien === "tab421" ? " active" : "")}
                      id="base-tab1"
                      data-toggle="tab"
                      aria-controls="tab1"
                      href="#tab421"
                      aria-expanded="true"
                    >
                      <h4>Thông tin cho vay</h4>
                    </a>
                  </li>
                  )}
                  {quyenThongTinKhac && (
                  <li className="nav-item">
                    <a
                      className={"nav-link" + (tabDauTien === "tab422" ? " active" : "")}
                      id="base-tab2"
                      data-toggle="tab"
                      aria-controls="tab2"
                      href="#tab422"
                      aria-expanded="false"
                    >
                      <h4>Thông tin khác</h4>
                    </a>
                  </li>
                  )}

                  {quyenThanhPhanGiaDinh && (
                  <li className="nav-item">
                    <a
                      className={"nav-link" + (tabDauTien === "tab423" ? " active" : "")}
                      id="base-tab2"
                      data-toggle="tab"
                      aria-controls="tab3"
                      href="#tab423"
                      aria-expanded="false"
                    >
                      <h4>Thành phần gia đình</h4>
                    </a>
                  </li>
                  )}
                </ul>
                <div className="tab-content px-1 pt-1 bg-content-tab">
                  <div
                    className={"tab-pane" + (tabDauTien === "tab421" ? " active" : "")}
                    id="tab421"
                    aria-expanded="true"
                    aria-labelledby="base-tab1"
                  >
                    <div className="row">
                      <div className="col-md-12">
                        <div className="row">
                          <div className="col-md-3">
                            <div className="form-group">
                              <label for="projectinput1">
                                Nguồn khách hàng
                              </label>
                              <select
                                name="ListHangTheChap[0].LoaiTaiSan"
                                className="form-control input-sm"
                                value={NguonKhId}
                                onChange={this._onSelect("NguonKhachHang")}
                              >
                                {comboNguonKhachHang &&
                                  comboNguonKhachHang.map((item, idx) => (
                                    <option
                                      key={"nguonKh" + idx}
                                      value={item.value}
                                    >
                                      {item.label}
                                    </option>
                                  ))}
                              </select>
                            </div>
                          </div>

                          <div className="col-md-3">
                            <div className="form-group">
                              <label for="projectinput1">Tình trạng</label>
                              <select
                                name="DebtLevel"
                                className="form-control input-sm"
                                value={DebtLevel}
                                onChange={this._onSelect("DebtLevel")}
                              >
                                <option value="0">Bình thường</option>
                                <option value="50">Nợ xấu</option>
                                <option value="20">Nợ rủi ro</option>
                              </select>
                            </div>
                          </div>

                          <div className="col-md-3">
                            <div className="form-group">
                              <label for="projectinput2">Loại đối tác</label>
                              <select
                                name="LoaiDoiTac"
                                className="form-control input-sm"
                                value={LoaiDoiTac}
                                onChange={this._onSelect("LoaiDoiTac")}
                              >
                                <option value="0">Chủ nợ</option>
                                <option value="1">Khách hàng</option>
                              </select>
                            </div>
                          </div>

                          <div className="col-md-3">
                            <div className="form-group">
                              <label for="projectinput2">Người theo dõi</label>
                              <select
                                name="Username"
                                className="selectBox form-control input-sm"
                                value={Username}
                                onChange={this._onSelect("Username")}
                              >
                                {nhanVienOption &&
                                  nhanVienOption.map(
                                    (item, idx) =>
                                      item.value != "0" && (
                                        <option
                                          key={"objNhanVien" + idx}
                                          value={item.value}
                                        >
                                          {item.label}
                                        </option>
                                      )
                                  )}
                              </select>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div
                    className={"tab-pane" + (tabDauTien === "tab422" ? " active" : "")}
                    id="tab422"
                    aria-labelledby="base-tab2"
                  >
                    <div className="row">
                      <div className="col-md-4">
                        <TextInputOnRow
                          labelClass="label-control"
                          inputClass="form-control input-sm"
                          wrapperClass="form-group"
                          labelText="Nghề nghiệp"
                          value={Profession}
                          inputProps={{
                            onChange: this.onChangeData("Profession"),
                          }}
                        ></TextInputOnRow>
                      </div>

                      <div className="col-md-4">
                        <TextInputOnRow
                          labelClass="label-control"
                          inputClass="form-control input-sm"
                          wrapperClass="form-group"
                          labelText="Nơi làm việc"
                          value={WorkAddress}
                          inputProps={{
                            onChange: this.onChangeData("WorkAddress"),
                          }}
                        ></TextInputOnRow>
                      </div>

                      <div className="col-md-4">
                        <TextInputOnRow
                          labelClass="label-control"
                          inputClass="form-control input-sm"
                          wrapperClass="form-group"
                          labelText="Thu nhập"
                          value={Income}
                          inputProps={{
                            onChange: this.onChangThuNhap("WorkAddress"),
                          }}
                        ></TextInputOnRow>
                      </div>

                      <div className="col-md-4">
                        <TextInputOnRow
                          labelClass="label-control"
                          inputClass="form-control input-sm"
                          wrapperClass="form-group"
                          labelText="Người liên hệ"
                          value={PersonContact}
                          inputProps={{
                            onChange: this.onChangeData("PersonContact"),
                          }}
                        ></TextInputOnRow>
                      </div>

                      <div className="col-md-4">
                        <TextInputOnRow
                          labelClass="label-control"
                          inputClass="form-control input-sm"
                          wrapperClass="form-group"
                          labelText="Số điện thoại người liên hệ"
                          value={PhoneContact}
                          inputProps={{
                            onChange: this.onChangeData("PhoneContact"),
                          }}
                        ></TextInputOnRow>
                      </div>

                      {quyenGhiChu && (
                      <div className="col-md-4">
                        <div className="form-group">
                          <label className="label-control" for="userinput1">
                            Ghi chú
                          </label>
                          <textarea
                            id="projectinput8"
                            rows=""
                            className="form-control input-sm"
                            name="comment"
                            placeholder=""
                            style={{ height: "29px" }}
                            value={Note}
                            onChange={this.onChangeData("Note")}
                          ></textarea>
                        </div>
                      </div>
                      )}
                    </div>
                  </div>

                  <div
                    className={"tab-pane" + (tabDauTien === "tab423" ? " active" : "")}
                    id="tab423"
                    aria-labelledby="base-tab2"
                  >
                    <div className="row">
                      <div className="col-md-6">
                        <TextInputTwoRow
                          labelClass="col-md-6 label-control text-right"
                          inputClass="form-control input-sm"
                          wrapperClass="form-group row"
                          labelText="Họ tên chồng/vợ"
                          inputWrapClass="col-md-6"
                        ></TextInputTwoRow>

                        <TextInputTwoRow
                          labelClass="col-md-6 label-control  text-right"
                          inputClass="form-control input-sm"
                          wrapperClass="form-group row"
                          labelText="Số điện thoại chồng/vợ"
                          inputWrapClass="col-md-6"
                        ></TextInputTwoRow>
                        <TextInputTwoRow
                          labelClass="col-md-6 label-control  text-right"
                          inputClass="form-control input-sm"
                          wrapperClass="form-group row"
                          labelText="Nghề nghiệp chồng/vợ"
                          inputWrapClass="col-md-6"
                        ></TextInputTwoRow>
                        <TextInputTwoRow
                          labelClass="col-md-6 label-control  text-right"
                          inputClass="form-control input-sm"
                          wrapperClass="form-group row"
                          labelText="Họ tên bố"
                          inputWrapClass="col-md-6"
                        ></TextInputTwoRow>
                        <TextInputTwoRow
                          labelClass="col-md-6 label-control  text-right"
                          inputClass="form-control input-sm"
                          wrapperClass="form-group row"
                          labelText="Số điện thoại bố"
                          inputWrapClass="col-md-6"
                        ></TextInputTwoRow>
                        <TextInputTwoRow
                          labelClass="col-md-6 label-control  text-right"
                          inputClass="form-control input-sm"
                          wrapperClass="form-group row"
                          labelText="Nghề nghiệp bố"
                          inputWrapClass="col-md-6"
                        ></TextInputTwoRow>
                      </div>

                      <div className="col-md-6 left-thongtin">
                        <TextInputTwoRowReverse
                          labelClass="col-md-6 label-control text-left"
                          inputClass="form-control input-sm"
                          wrapperClass="form-group row"
                          labelText="Họ tên mẹ"
                          inputWrapClass="col-md-6"
                        ></TextInputTwoRowReverse>

                        <TextInputTwoRowReverse
                          labelClass="col-md-6 label-control text-left"
                          inputClass="form-control input-sm"
                          wrapperClass="form-group row"
                          labelText="Số điện thoại mẹ"
                          inputWrapClass="col-md-6"
                        ></TextInputTwoRowReverse>

                        <TextInputTwoRowReverse
                          labelClass="col-md-6 label-control text-left"
                          inputClass="form-control input-sm"
                          wrapperClass="form-group row"
                          labelText="Nghề nghiệp mẹ"
                          inputWrapClass="col-md-6"
                        ></TextInputTwoRowReverse>
                        {quyenThongTinKhacGiaDinh && (
                        <div className="form-group row">
                          <div className="col-md-6">
                            <textarea
                              id="projectinput8"
                              rows="5"
                              className="form-control input-sm"
                              name="comment"
                              placeholder=""
                            ></textarea>
                          </div>
                          <label
                            className="col-md-6 label-control text-left"
                            for="userinput1"
                          >
                            Thông tin khác
                          </label>
                        </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </Modal.Body>
        <Modal.Footer>
          <a
            className="btn btn-new-main btn-checknew"
            href={() => false}
            onClick={this.onSumit}
          >
            <span className="btn-icon-left">
              <i className="mdi mdi-check"></i>
            </span>{" "}
            Thêm mới
          </a>
          <a
            type="button"
            className="btn btn-new-main btn-closenew"
            onClick={this.onHide}
          >
            <span className="btn-icon-left">
              <i className="mdi mdi-close"></i>
            </span>
            Đóng
          </a>
        </Modal.Footer>
      </Modal>
    );
  }
}
export default ThemMoiKhachHang;
